import React, { useState } from "react";
import styled from "styled-components";
import ceoImg from "../Assets/images/Mayoka Passport Size Photo  (2).jpg";

const Section = styled.section`
  padding: 5rem 0;
  background: #ffffff; /* Set background color to white */
`;

const Container = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  color: #333333;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
`;

const Highlight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(to right, #fff8e1, #ffffff);
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 4rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }

  img {
    width: 220px;
    height: 220px;
    border-radius: 100%;
    border: 4px solid #ffa726;
    object-fit: fit;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;

    @media (min-width: 640px) {
      width: 300px;
      height: 300px;
    }

    &:hover {
      transform: scale(1.05);
    }
  }
`;

const Info = styled.div`
  text-align: center;

  @media (min-width: 768px) {
    text-align: left;
    margin-left: 2rem;
  }
`;

const Name = styled.h3`
  font-size: 2rem;
  font-weight: bold;
  color: #424242;
  margin-bottom: 1rem;
`;

const Role = styled.p`
  font-size: 1.125rem;
  font-weight: 500;
  color: #ff7043;
  margin-bottom: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  color: #616161;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const ReadMore = styled.span`
  font-size: 1rem;
  color: #1565c0;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
  display: inline-block;
  margin-top: 10px;
  transition: all 0.3s ease;

  &:hover {
    color: #003c8f;
    text-decoration: underline;
    transform: translateY(-2px);
  }
`;

const TeamSection = () => {
  const fullText = [
    "Dr. Godfrey Mayoka is a distinguished academic and mentor with extensive experience in higher education and research. He holds a Bachelor’s degree from the University of Nairobi, as well as postgraduate degrees from University College London (UK) and the University of Cape Town (South Africa).",
    "His career includes prestigious postdoctoral research appointments, such as at the Helmholtz Institute for Pharmaceutical Research Saarland in Germany. With over a decade of academic and research experience spanning multiple continents, Dr. Mayoka has mentored numerous young African scholars in scientific writing and publication, helping them achieve their academic and professional goals. ",
    "Driven by a deep understanding of the unique challenges faced by African students and professionals—particularly in academic writing and accessing global opportunities—Dr. Mayoka founded Pristine Academic Consulting (PAC) to address these gaps. His wealth of experience, gained through transcontinental education, competitive fellowships, international conferences, publications in peer-reviewed journals, and service as a reviewer for leading journals and research councils, fuels his passion for guiding others toward success.",
    "Under Dr. Mayoka’s leadership, PAC is committed to empowering individuals from diverse academic and professional backgrounds, helping them realize their potential, navigate early career challenges, and excel in their respective fields.",
  ];

  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <Section>
      <Container>
        <Title>CEO & Founder</Title>

        <Highlight>
          <ImageWrapper>
            <img src={ceoImg} alt="CEO" />
          </ImageWrapper>
          <Info>
            <Name>Dr. Godfrey Mayoka</Name>
            <Role>CEO & Founder</Role>
            {fullText.slice(0, showMore ? fullText.length : 2).map((para, idx) => (
              <Paragraph key={idx}>{para}</Paragraph>
            ))}
            <ReadMore onClick={toggleShowMore}>
              {showMore ? "Show Less" : "Read More"}
            </ReadMore>
          </Info>
        </Highlight>
      </Container>
    </Section>
  );
};

export default TeamSection;
